var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        principles: true,
        container: true,
        mobile: _vm.isMobile(_vm.$mq)
      }
    },
    [
      _c(
        "h3",
        [
          _vm._t("header", [
            _vm._v("\n      Learn to think like a\n      "),
            _vm.titleNeedsBreak ? _c("br") : _vm._e(),
            _vm._v(" "),
            _c("strong", { class: _vm.currentOccupation.cssClass }, [
              _c("span", [_vm._v(_vm._s(_vm.occupationString))])
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.principles, function(principle, principleIndex) {
          return _c(
            "div",
            {
              key: principleIndex,
              staticClass: "item",
              class: principle.className
            },
            [
              _vm._m(0, true),
              _vm._v(" "),
              _c("div", { staticClass: "text" }, [
                _c("h4", [_vm._v(_vm._s(principle.title))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(principle.description))])
              ])
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("span", { staticClass: "b-sprite-homepage" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }